import React from 'react'
import Icon from 'components/Icon/Icon'
import { NavbarWrapper } from './styles'
import NavButtons from './NavButtons'
import LanguageFilter from './LanguageFilter'
import Profile from './Profile'
import Divider from 'components/Shared/Divider'
import Filter from './Filter'
import Helpdesk from './Helpdesk'
import { useSelector } from 'react-redux'
import { selectIsHelpdeskSupportedByActiveTeam } from 'state/filter'

const Navbar: React.FC = () => {
    const isHelpdeskSupported = useSelector(selectIsHelpdeskSupportedByActiveTeam)

    return (
        <>
            <NavbarWrapper>
                <div className="nav-container">
                    <div className="upper-container">
                        <Icon.Logo width={20} height={20} style={{ marginBottom: '20px' }} />
                        <Filter />
                        <Divider width="30px" />
                        <NavButtons />
                    </div>
                    <div className="second-container">
                        <Profile />
                        {isHelpdeskSupported && <Helpdesk />}
                        <Divider width="30px" />
                        <LanguageFilter />
                    </div>
                </div>
            </NavbarWrapper>
        </>
    )
}
export default Navbar
